/**
 * @Date:   2018-01-23T19:25:15+08:00
 * @Last modified time: 2018-01-26T11:38:33+08:00
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Button, Modal, Spin, DatePicker, Pagination, Checkbox, message } from 'antd';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import './style.less';

import { initSystemLogger,
  fetchSystemLogger,
  initSystemLoggerSetting,
  fetchSystemLoggerSetting,
  addSystemLoggerSetting,
  saveSystemLoggerSetting,
  fetchSystemModule } from '../../actions/system-setting-actions.js';

import { formatDateTime } from '../../utils/date-format';

const webConfig = require ('../../config.json');

const { RangePicker } = DatePicker;

const systemLoggerColumns =
[
  {title: '编号', dataIndex: 'id', key: 'id'},
  {title: '模块', dataIndex: 'module', key: 'module'},
  {title: '子模块', dataIndex: 'childModule', key: 'childModule'},
  {title: '日期时间', dataIndex: 'datetime', key: 'datetime'},
  {title: '操作', dataIndex: 'action', key: 'action'},
  {title: '描述', dataIndex: 'description', key: 'description'},
  {title: '执行者', dataIndex: 'executor', key: 'executor'},
  {title: '操作', dataIndex: 'detail', key: 'detail'}
];

const systemLoggerSettingColumns = [{
  title: '主模块',
  dataIndex: 'Name',
  key: 'Name'
}];

const systemLoggerSettingInnerColumns = [
  { title: '子项', dataIndex: 'Name', key: 'Name' },
  { title: '新增', dataIndex: 'CreateTag', key: 'CreateTag' },
  { title: '更新', dataIndex: 'UpdateTag', key: 'UpdateTag' },
  { title: '删除', dataIndex: 'DeleteTag', key: 'DeleteTag' },
  { title: '授权', dataIndex: 'AuthorizeTag', key: 'AuthorizeTag' },
  { title: '冻结', dataIndex: 'FrozenTag', key: 'FrozenTag' }
];

class SystemLogger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggerDetailModalOpen: false,
      isLoggerSettingModalOpen: false
    };
  }

  componentWillMount() {
    this.props.initSystemLogger();
    this.props.fetchSystemLogger();
    this.props.fetchSystemModule();
  }

  componentWillReceiveProps(nextProps) {
    this._handleSystemLoggerData(nextProps);
    this._handleSystemLoggerSettingData(nextProps);
  }

  _handleSystemLoggerData(nextProps) {
    this.setState({isSystemLoggerLoaded: nextProps.systemSetting.status});
    if ('loaded' === nextProps.systemSetting.status) {
      let systemLoggerDatas = [];
      nextProps.systemSetting.res.data.Data.forEach((data, index) => {
        let dateObject = formatDateTime(new Date(data.created_time));
        let datetime = dateObject.fullYear + '-' + dateObject.fullMonth + '-' + dateObject.fullDay;
        datetime += ' ' + dateObject.fullHour + ':' + dateObject.fullMinute + ':' + dateObject.fullSecond;
        let itemData =
        {
          key: index,
          id: data.id,
          module: data.controller_name,
          childModule: data.action_name,
          datetime: datetime,
          action: data.operation,
          description: '',
          executor: data.user_name,
          properties: data.properties,
          old_value: data.old_value,
          new_value: data.new_value,
          // detail: (<Button type="default" value={index} onClick={this.toggleLoggerDetailModal.bind(this, index)}>详情</Button>)
          detail: (<span onClick={this.toggleLoggerDetailModal.bind(this, index)}>
            <Button icon="info-circle-o" size="small" className="row-action-btn">详情</Button>
           {/* <Icon type="eye-o" className="icon-hover-pointer"  />*/}
          </span>)
        };
        systemLoggerDatas.push(itemData);
      });
      this.setState({systemLoggerDatas: systemLoggerDatas});
    }
  }

  _handleSystemLoggerSettingData(nextProps) {
    this.setState({isSystemLoggerSettingLoaded: nextProps.systemSetting.settingStatus});
    if ('loaded' === nextProps.systemSetting.settingStatus) {
      let systemLoggerSettingDatas = [];
      JSON.parse(nextProps.systemSetting.settingRes.data.setting).Modules.forEach((data, index) => {
        data.index = index;
        data.Children.forEach((childData, childIndex) => {
          data.Children[childIndex] =
          {
            index: childIndex,
            Name: childData.Name,
            Create:childData.Create,
            CreateTag: <Checkbox
              checked={childData.Create}
              onClick={this.changeSystemLoggerSetting.bind(this, index, childIndex, 'Create', childData.Create)} />,
            Update:childData.Update,
            UpdateTag: <Checkbox
              checked={childData.Update}
              onClick={this.changeSystemLoggerSetting.bind(this, index, childIndex, 'Update', childData.Update)} />,
            Delete:childData.Delete,
            DeleteTag: <Checkbox
              checked={childData.Delete}
              onClick={this.changeSystemLoggerSetting.bind(this, index, childIndex, 'Delete', childData.Delete)} />,
            Authorize:childData.Authorize,
            AuthorizeTag: <Checkbox
              checked={childData.Authorize}
              onClick={this.changeSystemLoggerSetting.bind(this, index, childIndex, 'Authorize', childData.Authorize)} />,
            Frozen:childData.Frozen,
            FrozenTag: <Checkbox
              checked={childData.Frozen}
              onClick={this.changeSystemLoggerSetting.bind(this, index, childIndex, 'Frozen', childData.Frozen)} />
          };
        });
        systemLoggerSettingDatas.push(data);
      });
      this.setState({systemLoggerSettingDatas: systemLoggerSettingDatas});
    }
  }

  changeSystemLoggerSetting(index, childIndex, action, actionValue) {
    let copyState = this.state.systemLoggerSettingDatas;
    copyState[index].Children[childIndex][action] = !actionValue;
    copyState[index].Children[childIndex][action + 'Tag'] = <Checkbox checked={!actionValue}
      onClick={this.changeSystemLoggerSetting.bind(this, index, childIndex, action, !actionValue)} />;
    this.setState({systemLoggerSettingDatas: copyState});
  }

  toggleLoggerSettingModal() {
    if (!this.state.isLoggerSettingModalOpen) {
      this.props.initSystemLoggerSetting();
    }
    this.props.fetchSystemLoggerSetting({orgnizationId: 1});
    this.setState({isLoggerSettingModalOpen: !this.state.isLoggerSettingModalOpen});
  }

  toggleLoggerDetailModal(index) {
    this.setState({currentSystemLoggerData: this.state.systemLoggerDatas[index]});
    this.setState({isLoggerDetailModalOpen: !this.state.isLoggerDetailModalOpen});
  }

  setControllerFilter(event) {
    this.setState({controllerFilter: event.target.value === '0'? '' : event.target.value});
  }

  setDateFilter(dates, moment) {
    this.setState({start_date: moment[0], end_date: moment[1]});
  }

  fetchCurrentFilter() {
    let filters = {};
    if (this.state.controllerFilter) {
      filters.controller_name = this.state.controllerFilter;
    }
    if (this.state.start_date) {
      filters.start_date = this.state.start_date;
    }
    if (this.state.end_date) {
      filters.end_date = this.state.end_date;
    }
    return filters;
  }

  fetchPageSystemLogger(page, pageSize) {
    let filters = this.fetchCurrentFilter();
    filters.PageSize = pageSize;
    filters.Page = page;
    this.props.fetchSystemLogger(filters);
  }

  fetchFilterSystemLogger() {
    let filters = this.fetchCurrentFilter();
    this.props.fetchSystemLogger(filters);
  }

  saveSystemLoggerSetting() {
    this.state.systemLoggerSettingDatas.forEach((data, index) => {
      data.Children.forEach((childData, childIndex) => {
        delete childData.CreateTag;
        delete childData.UpdateTag;
        delete childData.DeleteTag;
        delete childData.AuthorizeTag;
        delete childData.FrozenTag;
      });
    });
    let datas = {setting: JSON.stringify({Modules:this.state.systemLoggerSettingDatas})};
    if (this.props.systemSetting.settingRes.data.id) {
      datas.id = this.props.systemSetting.settingRes.data.id;
      this.props.saveSystemLoggerSetting(datas, status => {
        if (status) {
          this.setState({isLoggerSettingModalOpen: false});
          message.success("保存成功", 4);
        }else{
          this.setState({isSystemLoggerSettingLoaded: "saveError"});
          message.error("保存失败", 4);
        }
      });
    }else{
      this.props.addSystemLoggerSetting(datas, status => {
        if (status) {
          this.setState({isLoggerSettingModalOpen: false});
          message.success("保存成功", 4);
        }else{
          this.setState({isSystemLoggerSettingLoaded: "saveError"});
          message.error("保存失败", 4);
        }
      });
    }
  }

  render() {
    return (
      <div className="app-module-item">
        {this.props.access.systemLogger.set_value && <div style={{marginBottom:'10px'}}>
          <Button type="primary" onClick={this.toggleLoggerSettingModal.bind(this)}>设定记录模块</Button>
        </div>}
        <div style={{marginBottom:'10px'}}>
          <select defaultValue="0"
            style={{width:'116px',height:'32px',display:'inline-block',paddingLeft:'5px'}}
            onChange={this.setControllerFilter.bind(this)}>
            <option value="0">选择模块</option>
            {this.props.systemSetting.moduleStatus && this.props.systemSetting.moduleRes.data.map(option =>
              <option key={option.Value} value={option.Value}>{option.Text}</option>)}
          </select>
          <span style={{marginLeft:'20px',marginRight:'20px'}}>
            <span>起始日期 </span>
            <RangePicker
              style={{width: '300px'}}
              placeholder={['开始日期', '结束日期']}
              onChange={this.setDateFilter.bind(this)} />
          </span>
          <Button type="primary" onClick={this.fetchFilterSystemLogger.bind(this)}>显示</Button>
        </div>
      { 'loaded' === this.state.isSystemLoggerLoaded &&
        <div>
          <Table
            columns={systemLoggerColumns}
            pagination={false}
            dataSource={this.state.systemLoggerDatas} />
          <div style={{float:'right', marginTop:'20px'}}>
            <Pagination
              current={this.props.systemSetting.res.data.Page}
              defaultPageSize={this.props.systemSetting.res.data.PageSize}
              total={this.props.systemSetting.res.data.Total}
              onChange={this.fetchPageSystemLogger.bind(this)} />
          </div>
        </div>
      }
      { 'loading' === this.state.isSystemLoggerLoaded &&
        <div style={{textAlign:'center', margin: '100px 0px'}}><Spin size="large" /></div>
      }
      { 'error' === this.state.isSystemLoggerLoaded &&
        <div style={{textAlign:'center', margin: '100px 0px'}}>{webConfig.httpFetchErrorInformation}</div>
      }
      <Modal
        width="1000px"
        bodyStyle={{height:'600px'}}
        visible={this.state.isLoggerSettingModalOpen}
        title="设定记录模块"
        onCancel={this.toggleLoggerSettingModal.bind(this)}
        footer={<div>
          <Button key="cancel" type="back" onClick={this.toggleLoggerSettingModal.bind(this)}>关闭</Button>
          { 'error' !== this.state.isSystemLoggerSettingLoaded &&
          <Button key="ok" type="primary" onClick={this.saveSystemLoggerSetting.bind(this)}>提交</Button>
          }
        </div>}>
        {'loaded' === this.state.isSystemLoggerSettingLoaded &&
        <div style={{height:"552px",overflow:"auto"}}>
          <Table columns={systemLoggerSettingColumns}
            pagination={false}
            rowKey={record => record.index}
            dataSource={this.state.systemLoggerSettingDatas}
            expandedRowRender={ record =>
              <Table columns={systemLoggerSettingInnerColumns}
              dataSource={record.Children}
              pagination={false}
              rowKey={record => record.index} />
            } />
        </div>
        }
        {'loading' === this.state.isSystemLoggerSettingLoaded &&
          <div style={{textAlign:'center', margin: '100px 0px'}}><Spin size="large" /></div>
        }
        {'error' === this.state.isSystemLoggerSettingLoaded &&
          <div style={{textAlign:"center"}}>{webConfig.httpFetchErrorInformation}</div>
        }
        {'saveError' === this.state.isSystemLoggerSettingLoaded &&
          <div style={{textAlign:"center"}}>{webConfig.httpSaveErrorInformation}</div>
        }
      </Modal>
      { this.state.currentSystemLoggerData &&
        <Modal
          width="800px"
          visible={this.state.isLoggerDetailModalOpen}
          title="日志信息"
          onCancel={this.toggleLoggerDetailModal.bind(this)}
          footer={[<Button key="ok" type="back" onClick={this.toggleLoggerDetailModal.bind(this)}>关闭</Button>]}>
          <div style={{height: "400px", overflowY :"auto"}}>
          <p style={{width:"50%",float:"left"}}>
            <span>模块名称:{this.state.currentSystemLoggerData.module}</span>
          </p>
          <p style={{width:"50%",float:"left"}}>
            <span>子项名称:{this.state.currentSystemLoggerData.childModule}</span>
          </p>
          <p style={{width:"50%",float:"left"}}>
            <span>执行者:{this.state.currentSystemLoggerData.executor}</span>
          </p>
          <p style={{width:"50%",float:"left"}}>
            <span>执行时间:{this.state.currentSystemLoggerData.datetime}</span>
          </p>
          <p style={{width:"50%",float:"left"}}>
            <span>操作:{this.state.currentSystemLoggerData.action}</span>
          </p>
          <p style={{width:"50%",float:"left"}}>
            <span>操作属性:{this.state.currentSystemLoggerData.properties}</span>
          </p>
          <p style={{width:"50%",float:"left"}}>
            <span>初始值:{this.state.currentSystemLoggerData.old_value}</span>
          </p>
          <p style={{width:"50%",float:"left"}}>
            <span>更新值:{this.state.currentSystemLoggerData.new_value}</span>
          </p>
          </div>
        </Modal>
      }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    systemSetting: state.systemSetting
  }
}

SystemLogger = connect(mapStateToProps, {
  initSystemLogger,
  fetchSystemLogger,
  initSystemLoggerSetting,
  fetchSystemLoggerSetting,
  addSystemLoggerSetting,
  saveSystemLoggerSetting,
  fetchSystemModule
})(SystemLogger);

SystemLogger = LayoutWrapper(SystemLogger);

export default SystemLogger;



// WEBPACK FOOTER //
// ./src/routes/SystemSetting/SystemLogger.js